import React, { useState, useEffect } from "react";
import { FileText, Eye } from "lucide-react";
import { useLanguage } from "../StoreContext/LanguageContext";
import apiService from "../config";

const Section21 = ({ setSubComponent }) => {
  const { language, translations } = useLanguage();
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [currentProposalId, setCurrentProposalId] = useState(null);

  const [uploadingDataEntry, setUploadingDataEntry] = useState(false);
  const [uploadedDataEntryFileUrl, setUploadedDataEntryFileUrl] = useState('');
  const [showDocumentViewer, setShowDocumentViewer] = useState(false);
  const [fileUrlToView, setFileUrlToView] = useState('');
  const [isPDFToView, setIsPDFToView] = useState(false);
  
  const userData = JSON.parse(localStorage.getItem('userData'));
  const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);

  const ROLES = {
    DATA_ENTRY: 14
  };

  // ✅ Fetch projectId
  useEffect(() => {
    const getProjectInfo = () => {
      const currentProjectData = localStorage.getItem("currentProjectData");
      if (currentProjectData) {
        try {
          const projectData = JSON.parse(currentProjectData);
          return {
            id: projectData.project_id || projectData.id,
            name: projectData.project_name || projectData.name,
          };
        } catch (e) {
          console.error("Error parsing currentProjectData:", e);
        }
      }
      const selectedProject = localStorage.getItem("selectedProject");
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name,
          };
        } catch (e) {
          console.error("Error parsing selectedProject:", e);
        }
      }
      const userData = localStorage.getItem("userData");
      if (userData) {
        try {
          const user = JSON.parse(userData);
          return {
            id: user.data?.project_id || user.project_id,
            name: user.data?.project_name || user.project_name,
          };
        } catch (e) {
          console.error("Error parsing userData:", e);
        }
      }
      return { id: null, name: null };
    };

    const projectInfo = getProjectInfo();
    setCurrentProjectId(projectInfo.id);
  }, []);

  // ✅ Fetch proposalId
  useEffect(() => {
    const getProposalInfo = () => {
      const currentProposal = JSON.parse(
        localStorage.getItem("userData") || "{}"
      );
      if (currentProposal) {
        try {
          return (
            currentProposal?.data?.default_proposal ||
            currentProposal?.data?.proposal_id ||
            currentProposal?.default_proposal ||
            currentProposal?.proposal_id ||
            null
          );
        } catch (e) {
          console.error("Error parsing proposal:", e);
        }
      }
      return null;
    };

    setCurrentProposalId(getProposalInfo());
    
  }, []);
useEffect(()=>{
  fetchButtonStatus()
})
  // ✅ Pre-load existing uploaded document URL so View button shows on reload
  useEffect(() => {
    const fetchExistingFile = async () => {
      if (!currentProjectId || !currentProposalId) return;
      try {
        const fileResponse = await apiService.getSectionFile(currentProjectId, currentProposalId, "section21");
        if (fileResponse?.status === 200 && fileResponse.data?.length > 0) {
          setUploadedDataEntryFileUrl(fileResponse.data[0].file_path);
        }
      } catch (err) {
        // No file yet, that's fine
      }
    };
    fetchExistingFile();
  }, [currentProjectId, currentProposalId]);
  // ✅ ADD THESE
  const handleViewDocument = (urlOrFile) => {
    if (!urlOrFile) return;
    let url, isPdf;
    if (urlOrFile instanceof File) {
      url = URL.createObjectURL(urlOrFile);
      isPdf = urlOrFile.type === 'application/pdf';
    } else {
      url = urlOrFile;
      isPdf = urlOrFile.toLowerCase().includes('.pdf');
    }
    setFileUrlToView(url);
    setIsPDFToView(isPdf);
    setShowDocumentViewer(true);
  };

  const closeDocumentViewer = () => {
    setShowDocumentViewer(false);
    if (fileUrlToView.startsWith('blob:')) {
      URL.revokeObjectURL(fileUrlToView);
    }
    setFileUrlToView('');
    setIsPDFToView(false);
  };
  // ✅ Button Handlers
  const handleSection21_1 = () => setSubComponent("Section21_1");
  const handleSection21_1_4 = () => setSubComponent("Section21_1_4");
  const handleUnderSection21 = () => setSubComponent("UnderSection21");

  const handleDataEntryFileSelect = async (e) => {
    const file = e.target.files[0];

    if (!file) {
      return;
    }

    if (!currentProjectId || !currentProposalId) {
      alert('Project ID and Proposal ID are required.');
      e.target.value = ''; // Reset file input
      return;
    }

    // Show confirmation alert
    const userConfirmed = window.confirm(
      `Selected file: ${file.name}\n\nDo you want to upload this document?`
    );

    if (!userConfirmed) {
      e.target.value = ''; // Reset file input
      return;
    }

    setUploadingDataEntry(true);

    try {
      const response = await apiService.postAddSignaturePDF(
        currentProjectId,
        currentProposalId,
        "section21",
        file
      );

      // AFTER
      if (response.status === 200) {
        alert('Document uploaded successfully!');

        // ✅ Fetch and store uploaded document URL for View button
        try {
          const fileResponse = await apiService.getSectionFile(currentProjectId, currentProposalId, "section21");
          if (fileResponse?.status === 200 && fileResponse.data?.length > 0) {
            setUploadedDataEntryFileUrl(fileResponse.data[0].file_path);
          }
        } catch (err) {
          console.error("Error fetching uploaded file URL:", err);
        }
      }
    } catch (error) {
      console.error('Error uploading document:', error);
      alert('Failed to upload document. Please try again.');
    } finally {
      setUploadingDataEntry(false);
      e.target.value = ''; // Reset file input for next upload
    }
  };
  const [pageActive , setPageActive] = useState(false)
  const fetchButtonStatus = async () => {
      try {
        if (!currentProjectId || !currentProposalId) return;
  
        // setLoading(true);
        
  
        // Edit button disable
        const response = await apiService.getSendbutton(currentProjectId,currentProposalId,"LAOPublishSection19");
        console.log("Sec19 button" , response);
        setPageActive(response?.buttonDisable)
        
        
  
       
        
      } catch (error) {
        console.error("Error fetching DSLR button state:", error);
      } finally {
        // setLoading(false); // Only set loading to false for main data fetch
      }
    };
     const[disable,setDisable] = useState(false)
         useEffect(() => {
          const fetchButtonState = async () => {
            try {
              if (!currentProjectId || !currentProposalId) return;
        
              const res = await apiService.getTrackingwiseButton(currentProjectId,currentProposalId,"section19");
             
              console.log("Sec 19 button for sec 21" , res);
              setDisable(res?.stages?.LAOPublishSection19?.complete)
            
            
              console.log("Button State" , disable);
              console.log("Button State" , res?.stages?.Compensation?.complete);
              
              
        
              console.log("API response:", res);
        
              // Correct mapping
            //   setButtonDisabled(!res?.isEditable);
        
            } catch (error) {
              console.error("Error fetching button state:", error);
            //   setButtonDisabled(true); // fail-safe
            }
          };
        
          fetchButtonState();
        }, [currentProjectId, currentProposalId]);

  return (
    <>
      <div className="p-6">
        {disable ?
        <div className="flex flex-wrap gap-4">
          <button
            onClick={handleSection21_1}
            className="px-5 py-3 text-sm bg-green-600 hover:bg-green-700 text-white rounded-xl flex items-center space-x-2 shadow-md"
          >
            <FileText className="h-5 w-5" />
            <span>{translations[language].Section21_1}</span>
          </button>

          <button
            onClick={handleSection21_1_4}
            className="px-5 py-3 text-sm bg-green-600 hover:bg-green-700 text-white rounded-xl flex items-center space-x-2 shadow-md"
          >
            <FileText className="h-5 w-5" />
            <span>{translations[language].Section21_1_4}</span>
          </button>

          <button
            onClick={handleUnderSection21}
            className="px-5 py-3 text-sm bg-green-600 hover:bg-green-700 text-white rounded-xl flex items-center space-x-2 shadow-md"
          >
            <FileText className="h-5 w-5" />
            <span>{translations[language].UnderSection21}</span>
          </button>

          {userRole === ROLES.DATA_ENTRY && (
            <>
              <input
                type="file"
                id="dataEntryFileInput"
                onChange={handleDataEntryFileSelect}
                className="hidden"
                accept=".pdf,.doc,.docx"
                disabled={uploadingDataEntry}
              />
              <label
                htmlFor="dataEntryFileInput"
                className={`px-6 py-2 rounded-lg flex items-center space-x-2 cursor-pointer ${uploadingDataEntry
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-green-600 text-white hover:bg-green-700'
                  }`}
              >
                {uploadingDataEntry ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    <span>Uploading...</span>
                  </>
                ) : (
                  <span>Upload Document</span>
                )}
              </label>

              {/* ✅ View button — shown only after upload succeeds */}
              {uploadedDataEntryFileUrl && (
                <button
                  type="button"
                  onClick={() => handleViewDocument(uploadedDataEntryFileUrl)}
                  className="px-5 py-3 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded-xl flex items-center space-x-2 shadow-md"
                  title="View Uploaded Document"
                >
                  <Eye className="h-5 w-5" />
                  <span>View</span>
                </button>
              )}
            </>
          )}
        </div>
          : "Previous Step is Not Completed" } 
      </div>
      {showDocumentViewer && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl w-full max-w-5xl h-[95vh] shadow-2xl overflow-hidden border border-gray-200">
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
              <h3 className="text-2xl font-bold text-blue-900 tracking-tight">Document Preview</h3>
              <button
                onClick={closeDocumentViewer}
                className="w-10 h-10 rounded-full bg-gray-100 hover:bg-red-100 text-gray-500 hover:text-red-500 transition-all duration-200 flex items-center justify-center text-xl font-bold"
              >
                ×
              </button>
            </div>
            {/* Content */}
            <div className="h-[calc(95vh-65px)]">
              <div className="w-full h-full">
                {isPDFToView ? (
                  <iframe
                    src={fileUrlToView}
                    className="w-full h-full border-0 bg-white"
                    title="PDF Preview"
                  />
                ) : (
                  <img
                    src={fileUrlToView}
                    alt="File"
                    className="w-full h-full object-contain"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )
      }
    </>

  );
};

export default Section21;
